import { render } from "./AlbumTemplatesList.vue?vue&type=template&id=0e4c9f20&scoped=true"
import script from "./AlbumTemplatesList.vue?vue&type=script&lang=js"
export * from "./AlbumTemplatesList.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0e4c9f20&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c9f20"]])

export default __exports__